import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";

const FullScreenLoader = ({ loading, message = "" }) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,  
        display: loading ? "flex" : "none",
        flexDirection: "column",  
        justifyContent: "center", 
        alignItems: "center",     
        textAlign: "center",      
      }}
      open={loading}
    >
      <p>{message}</p>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};

export default FullScreenLoader;
